var render = function (_h,_vm) {var _c=_vm._c;return _c('div',[_c('h2',{staticClass:"wallet-title pt-4 pl-4",attrs:{"id":"title"}},[_vm._v(" "+_vm._s(_vm.props.title)+" ")]),_c('p',{staticClass:"wallet-subTitle pl-4",attrs:{"id":"text"}},[_vm._v(" "+_vm._s(_vm.props.text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }